export default class SkillFilter {
  constructor (skillFilterData) {
    this.id = skillFilterData.id
    this.name = skillFilterData.name
  }
}
